
/**
 * Static database for the map
 * @property {number} floorIndex - Order of the floor
 * @property {array} vertices - Vertices on map to traverse
 * @property {array} connections - Path (connection between vertices) that could be traversed through map
 */
import { facility, touchDevices } from 'config/constants';
import connections from './connections.json';
import vertices from './vertices.json';
import titleRotates from './titleRotates.json';

export const availableTouchDevices = [81, 91, 110, 139, 142, 143, 126];

export default {
  floorIndex: 3,
  vertices,
  connections,
  titleRotates,
  deviceLocations: availableTouchDevices,
  [facility.elevators]: [84, 62, 68, 74],
  [facility.escalators]: [58, 60, 63, 66, 72],
  [facility.toilets]: [61, 64, 70, 73],
  [facility.atms]: [],
  [facility.restArea]: [59, 69],
  [facility.chargeArea]: [67, 71],
  [facility.lockers]: [],
  [facility.babyCare]: [144],
  [facility.smokeArea]: [65],
  [facility.infoStall]: [],
  [facility.taxi]: []
};

export { vertices, titleRotates };
